import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import VueMobileDetection from "vue-mobile-detection";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyApaouB08Zj28KecB8NQWsP4-XWVkS5_Es",
    authDomain: "energy-hub-app.firebaseapp.com",
    projectId: "energy-hub-app",
    storageBucket: "energy-hub-app.appspot.com",
    messagingSenderId: "994400881130",
    appId: "1:994400881130:web:d90fa29a46b2ddb30dca93",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
getAuth(app);
getFirestore(app);

loadFonts();

createApp(App).use(VueMobileDetection).use(router).use(store).use(vuetify).mount("#app");
